import { t } from 'i18next'
import { useCallback, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import styled from 'styled-components'
import { BackButton, PageContentDropdown, SubHeader } from '../../components'
import useWorkspaceDetails from '../../hooks/useWorkspaceDetails'
import { routePaths } from '../RootPage'
import {
  WorkspaceTab,
  workspacePanelTypes,
  workspaceTabs,
} from './WorkspaceDetailsPage'
import DeviationStatusSwitch from './components/DeviationStatusSwitch'
import DocumentSetDetailsPageLayout from './components/DocumentSetDetailsPageLayout'
import DocumentSetDetailsPageTabs from './components/DocumentSetDetailsPageTabs'
import WorkspaceOverviewInfoDeviationPanel from './panels/WorkspaceOverviewInfoDeviationPanel'
import WorkspaceSmartFunctionPanel from './panels/WorkspaceSmartFunctionPanel'

const ListPanelLayout = styled.div`
  height: calc(100vh - 124px);
  border-radius: 16px 16px 0px 0px;
`

const FloatLeftContainer = styled.div`
  display: flex;
  margin-left: auto;
  order: 2;
  gap: 8px;
  align-items: center;
  margin-left: auto;
  white-space: nowrap;
`

const WorkspaceRiskReliefDeviationDetailsPage = () => {
  const { workspaceId, deviationId, tab } = useParams()
  const navigate = useNavigate()
  const [fetchDone, setFetchDone] = useState(false)

  const { refreshWorkspaceDetails } = useWorkspaceDetails({
    workspaceId,
    preventFetch: true,
  })

  const [selectedWorkspaceTab, setSelectedWorkspaceTab] = useState(
    tab as WorkspaceTab
  )

  useEffect(() => {
    if (!fetchDone) {
      refreshWorkspaceDetails()
      setFetchDone(true)
    }
  }, [fetchDone, refreshWorkspaceDetails])

  const handleChange = (value: string) => {
    setSelectedWorkspaceTab(value as WorkspaceTab)
    navigate(
      `${routePaths.WORKSPACE_DETAILS}/${workspaceId}/${workspacePanelTypes.DEVIATIONS}/${value}/${deviationId}`
    )
  }

  const handleWorkspaceDetailsPanelExport = () => {}

  const renderPanel = useCallback(() => {
    switch (selectedWorkspaceTab) {
      case workspaceTabs.INFO:
        return <WorkspaceOverviewInfoDeviationPanel />
      case workspaceTabs.SMART_FUNCTION:
        return <WorkspaceSmartFunctionPanel />
      default:
        return <WorkspaceOverviewInfoDeviationPanel />
    }
  }, [selectedWorkspaceTab])

  return (
    <DocumentSetDetailsPageLayout selectedWorkspaceTab={selectedWorkspaceTab}>
      <SubHeader>
        <BackButton
          type="default"
          tooltipMessage={t('workspaceDetailsPage.backToDeviations')}
          url={`${routePaths.WORKSPACE_DETAILS}/${workspaceId}/${workspacePanelTypes.DEVIATIONS}/${workspaceTabs.INFO}`}
        />
        <DocumentSetDetailsPageTabs
          selectedWorkspaceTab={selectedWorkspaceTab}
          handleChange={handleChange}
        />

        <FloatLeftContainer>
          <DeviationStatusSwitch />
          <PageContentDropdown onExport={handleWorkspaceDetailsPanelExport} />
        </FloatLeftContainer>
      </SubHeader>
      <ListPanelLayout>{renderPanel()}</ListPanelLayout>
    </DocumentSetDetailsPageLayout>
  )
}

export default WorkspaceRiskReliefDeviationDetailsPage
